import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import StaffingCompliancePage from "@/pages/admin/StaffingCompliancePage";

export const Route = createFileRoute("/_admin/admin/staffing-compliance")({
  head: () => pageHead("Admin · Staffing Compliance", "AKIVA admin · staffing compliance portal.", "/admin/staffing-compliance", true),
  component: StaffingCompliancePage,
});
